import React from 'react';
import TemplateReviewWizard from '@/components/templates/TemplateReviewWizard.jsx';
import { TEMPLATE_FIELD_POLICY } from '@/constants/templateWizardPolicy.js';

const CreateFromTemplate = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-6xl">
      <TemplateReviewWizard
        fieldPolicy={TEMPLATE_FIELD_POLICY.REQUIRE_ALL_REPLACED}
        enableSecureSubmit
        secureSubmitDocumentType="productDevelopment"
        onError={(message, err) => {
          // Keep logs lightweight but useful for support triage.
          // Avoid noisy logs in normal usage.
          console.error('[CreateFromTemplate] wizard_error', { message, err });
        }}
        onSecureSubmitted={(result) => {
          console.info('[CreateFromTemplate] template_submitted_secure_storage', { s3Key: result?.s3Key });
        }}
      />
    </div>
  );
};

export default CreateFromTemplate;

